import { DateWithTimezones } from '../../../../../common/models/status-history-chain.model';
export interface ShipmentDeliveryDatesModel {
  estimatedDeliveryDate: DateWithTimezones | null;
  actualDeliveryDate: DateWithTimezones | null;
}
